    
    import { Mapper } from "../../../../base/utils/mapper";
    import { TypeInvoiceModel } from "../../../../domain/models/configuration/type-invoice.model";
    import { TypeInvoiceEntity } from "../entities/type-invoice.entity";
     
        export class TypeInvoiceImplementationRepositoryMapper extends Mapper<TypeInvoiceEntity, TypeInvoiceModel>{
            mapFrom(param:  TypeInvoiceEntity):  TypeInvoiceModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  TypeInvoiceModel):  TypeInvoiceEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }